import React, { useState } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { FaAngleDoubleRight } from "react-icons/fa"

import Technology from "../UI/Technology/technology"
import Title from "../UI/Title/title"
import classes from "./jobs.module.scss"

const Jobs = props => {
  const { t } = useTranslation()
  const myJobs = t("jobsSection.jobs", { returnObjects: true })
  const [selectedJobId, setSelectedJobId] = useState(myJobs[0].id)

  const selectedJob = myJobs.find(job => job.id === selectedJobId)

  return (
    <section className={classes.JobsSection}>
      <Title type="primary">{props.title}</Title>
      <div className={classes.Center}>
        <div className={classes.BtnContainer}>
          {myJobs.map(job => (
            <button
              key={job.id}
              className={
                job.id === selectedJobId
                  ? `${classes.JobButton} ${classes.JobButtonActive}`
                  : classes.JobButton
              }
              onClick={() => setSelectedJobId(job.id)}
            >
              {job.position}
            </button>
          ))}
        </div>
        <div className={classes.JobInfo}>
          <h3>{selectedJob.position}</h3>
          <div className={classes.JobCompany}>
            <Technology>{selectedJob.company}</Technology>
          </div>
          <p className={classes.JobDate}>{selectedJob.workPeriod}</p>
          <div className={classes.JobDescriptions}>
            {selectedJob.descriptionItems.map(description => (
              <div key={description.id} className={classes.JobDescription}>
                <FaAngleDoubleRight
                  className={classes.JobIcon}
                ></FaAngleDoubleRight>
                <p>{description.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Jobs
